import { ThunkResult } from "../../shared/utilities";
import { IAction } from "../model/IAction";
import { IProcessVariable } from "../model/IProcessData";
import { State } from "../model/State";
import { validationAction } from "./ValidateProcess";

export function addProcessVariable(): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerAddProcessVariable());
        dispatch(validationAction(getState()));
    };
}

export function updateProcessVariableName(id: number, newName: string): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerUpdateProcessVariableName(id, newName));
        dispatch(validationAction(getState()));
    };
}

export function updateProcessVariableValue(id: number, newValue: string): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerUpdateProcessVariableValue(id, newValue));
        dispatch(validationAction(getState()));
    };
}

export function updateProcessVariableMode(id: number, newMode: string): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerUpdateProcessVariableMode(id, newMode));
        dispatch(validationAction(getState()));
    };
}

export function updateProcessVariableDescription(id: number, newDescription: string): ThunkResult<void, State> {
    return (dispatch) => {
        dispatch(triggerUpdateProcessVariableDescription(id, newDescription));
    };
}

export function removeProcessVariable(id: number): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerRemoveProcessVariable(id));
        dispatch(validationAction(getState()));
    };
}

export function reorderProcessVariables(oldIndex: number, newIndex: number): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerReorderProcessVariables(oldIndex, newIndex));
        dispatch(validationAction(getState()));
    };
}

export const RECEIVE_PROCESS_VARIABLES = "RECEIVE_PROCESS_VARIABLES";
export function receiveProcessVariables(processVariables: IProcessVariable[]): ReceiveProcessVariablesAction {
    return {
        type: RECEIVE_PROCESS_VARIABLES,
        processVariables: processVariables
    };
}

export const ADD_PROCESS_VARIABLE = "ADD_PROCESS_VARIABLE";
export function triggerAddProcessVariable(): IAction {
    return {
        type: ADD_PROCESS_VARIABLE,
    };
}

export const UPDATE_PROCESS_VARIABLE_NAME = "UPDATE_PROCESS_VARIABLE_NAME";
export function triggerUpdateProcessVariableName(id: number, newName: string): UpdateProcessVariableNameAction {
    return {
        type: UPDATE_PROCESS_VARIABLE_NAME,
        id: id,
        newName: newName,
    };
}

export const UPDATE_PROCESS_VARIABLE_VALUE = "UPDATE_PROCESS_VARIABLE_VALUE";
export function triggerUpdateProcessVariableValue(id: number, newValue: string): UpdateProcessVariableValueAction {
    return {
        type: UPDATE_PROCESS_VARIABLE_VALUE,
        id: id,
        newDisplayValue: newValue,
    };
}

export const UPDATE_PROCESS_VARIABLE_MODE = "UPDATE_PROCESS_VARIABLE_MODE";
export function triggerUpdateProcessVariableMode(id: number, newMode: string): UpdateProcessVariableModeAction {
    return {
        type: UPDATE_PROCESS_VARIABLE_MODE,
        id: id,
        newMode: newMode,
    };
}

export const UPDATE_PROCESS_VARIABLE_DESCRIPTION = "UPDATE_PROCESS_VARIABLE_DESCRIPTION";
export function triggerUpdateProcessVariableDescription(id: number, newDescription: string): UpdateProcessVariableDescriptionAction {
    return {
        type: UPDATE_PROCESS_VARIABLE_DESCRIPTION,
        id: id,
        newDescription: newDescription,
    };
}

export const TOGGLE_PROCESS_VARIABLE_IS_SECRET = "TOGGLE_PROCESS_VARIABLE_IS_SECRET";
export function toggleProcessVariableIsSecret(id: number): ToggleProcessVariableIsSecretAction {
    return {
        type: TOGGLE_PROCESS_VARIABLE_IS_SECRET,
        id: id,
    };
}

export const REMOVE_PROCESS_VARIABLE = "REMOVE_PROCESS_VARIABLE";
export function triggerRemoveProcessVariable(id: number): RemoveProcessVariableAction {
    return {
        type: REMOVE_PROCESS_VARIABLE,
        id: id,
    };
}

export const REORDER_PROCESS_VARIABLES = "REORDER_PROCESS_VARIABLE";
export function triggerReorderProcessVariables(oldIndex: number, newIndex: number): ReorderProcessVariablesAction {
    return {
        type: REORDER_PROCESS_VARIABLES,
        oldIndex: oldIndex,
        newIndex: newIndex,
    };
}

export interface ReceiveProcessVariablesAction extends IAction {
    processVariables: IProcessVariable[];
}

export interface AddProcessVariableAction extends IAction {
    id: number;
}

export interface UpdateProcessVariableNameAction extends IAction {
    id: number;
    newName: string;
}

export interface UpdateProcessVariableValueAction extends IAction {
    id: number;
    newDisplayValue: string;
}

export interface UpdateProcessVariableDescriptionAction extends IAction {
    id: number;
    newDescription: string;
}

export interface UpdateProcessVariableModeAction extends IAction {
    id: number;
    newMode: string;
}

export interface ToggleProcessVariableIsSecretAction extends IAction {
    id: number;
}

export interface RemoveProcessVariableAction extends IAction {
    id: number;
}

export interface ReorderProcessVariablesAction extends IAction {
    oldIndex: number;
    newIndex: number;
}
